import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireBundle } from "C:\\xampp\\htdocs\\youmore\\wp-content\\themes\\youmore\\src\\js\\bundle\\index.js";
var bundleExports = requireBundle();
export { bundleExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(bundleExports);